import React, { useEffect, useCallback, useState} from 'react';
import ScriptTidals from "components/effects/scripting/ScriptTidals.js";
import {connect} from 'react-redux';

const JakiGraphics = ({jgraphics, tidals, width, height}) => { 
    if (!tidals) {
        return '';
    }

    if (width <= 0) {
        width = 280;
        height= 280;
    } else {
        width*=1;
        height*=1;
    }
    return (<ScriptTidals
              color={jgraphics.color}
              fillColor={jgraphics.fillColor}
              backgroundColor={jgraphics.backgroundColor}
              dotColor={jgraphics.dotColor}
              tidals={tidals}
              WIDTH={width}
              HEIGHT={height}/>);
}

const mapStateToProps = (state, props) => {
  return {
      tidals: props.jgraphics && props.jgraphics.tidals,
      color: props.jgraphics && props.jgraphics.color,
      backgroundColor: props.jgraphics && props.jgraphics.backgroundColor,
      fillColor: props.jgraphics && props.jgraphics.fillColor,
      dotColor: props.jgraphics && props.jgraphics.dotColor
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JakiGraphics);
